import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useUserContext } from 'providers/UserProvider';

import { toast } from 'react-toastify';
import Table from 'components/common/Table';

import { picklistApi } from 'api';

import { getPicklistDetailItemsColumns } from 'constants/picklist';

const PicklistProducts = ({ picklistId, onScanStatusChange }) => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const [scannedQuantities, setScannedQuantities] = useState({});
  const [barcodeInput, setBarcodeInput] = useState('');
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (items.length > 0) {
      const allScanned = items.every(item => {
        const total = item.shipment_line_summary?.total_quantity || 0;
        const scanned = scannedQuantities[item.barcode] || 0;
        return total - scanned === 0;
      });
      onScanStatusChange?.(allScanned);
    } else {
      onScanStatusChange?.(false);
    }
  }, [items, scannedQuantities, onScanStatusChange]);

  const handleDataChange = useCallback(data => {
    setItems(data);
  }, []);

  const handleBarcodeScan = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const barcode = barcodeInput.trim();
      if (!barcode) return;

      const item = items.find(i => i.barcode === barcode);

      if (item) {
        const currentScanned = scannedQuantities[barcode] || 0;
        const totalQuantity = item.shipment_line_summary?.total_quantity || 0;

        if (currentScanned + 1 > totalQuantity) {
          toast.error('Scanned Quantity cannot exceed Total Quantity');
        } else {
          setScannedQuantities(prev => ({
            ...prev,
            [barcode]: currentScanned + 1,
          }));
        }
      } else {
        toast.error('Barcode not found');
      }
      setBarcodeInput('');
    }
  };

  const columns = useMemo(() => {
    const baseColumns = getPicklistDetailItemsColumns(tenant, warehouse);
    return baseColumns.map(col => {
      if (col.accessorKey === 'scanned_quantity') {
        return {
          ...col,
          cell: ({ row: { original } }) =>
            scannedQuantities[original.barcode] || 0,
        };
      }
      return col;
    });
  }, [tenant, warehouse, scannedQuantities]);

  const headerActions = (
    <Form.Control
      type="text"
      placeholder="Scan Barcode"
      size="sm"
      value={barcodeInput}
      onChange={e => setBarcodeInput(e.target.value)}
      onKeyDown={handleBarcodeScan}
      style={{ width: '200px' }}
    />
  );

  return (
    <Table
      title={`Picklists #${picklistId} Items`}
      apiService={picklistApi}
      columns={columns}
      fetchConfig={{
        method: 'getProductsOfPicklist',
        enablePagination: true,
      }}
      resourceId={picklistId}
      initialPageSize={25}
      initialFilter={{ tab: 'items' }}
      headerActions={headerActions}
      onDataChange={handleDataChange}
    />
  );
};

export default PicklistProducts;
